var _path, _path2, _path3, _line, _line2, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorOpenBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5H13C15.4853 1.5 17.5 3.51472 17.5 6V19C17.5 20.3807 16.3807 21.5 15 21.5H8C6.61929 21.5 5.5 20.3807 5.5 19V6C5.5 3.51472 7.51472 1.5 10 1.5Z",
    stroke: "#000000",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.99757C10.5294 6.6606 12.4998 6.67437 16 7.99757L15 13C11.459 11.681 11.4862 11.7066 8 13L7 7.99757Z",
    stroke: "#000000",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22681 19.1162C11.1753 19.257 12.1743 19.2637 15.2268 19.1162C15.8277 18.8073 16.0115 18.1419 16 16C13.325 16.5002 9.78739 16.5032 7 16C7.03921 17.9724 7.25357 18.7475 8.22681 19.1162Z",
    stroke: "#000000",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.35355,
    y1: 9.35355,
    x2: 1.35355,
    y2: 13.3536,
    stroke: "#000000"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.3536,
    y1: 9.35355,
    x2: 22.3536,
    y2: 13.3536,
    stroke: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.50007C6.66667 8.16674 4.7 7.70007 3.5 8.50007",
    stroke: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 8.50007C18.7668 8.16674 16.8001 7.70007 15.6001 8.50007",
    stroke: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenBlack);
export default __webpack_public_path__ + "static/media/door-open-black.d27db3435d46c2d71903c730a7d822b0.svg";
export { ForwardRef as ReactComponent };